import React from 'react';
import './progress-bar.scss';

export default function ProgressBar() {
  return <div className="progress-bar" />;
}
